import {
  getLocalTrack,
  MEDIA_TYPE,
  useBaseStore,
  useTracksStore,
} from '@cometchat/calls-sdk-core';
import { NoiseSuppressionEffect } from './NoiseSuppressionEffect';

function enableNoiseReductionEffect() {
  const isMobileBrowser = useBaseStore.getState().isMobileBrowser;
  if (isMobileBrowser) {
    // Skip on mobile browsers: noise suppression has minimal effect, and on
    // iOS Safari it causes an InvalidStateError when the audio device restarts
    // after a system-level call interruption.
    return;
  }
  const audioTrack = getLocalTrack(MEDIA_TYPE.AUDIO)?.originalTrack;
  if (audioTrack) {
    audioTrack.setEffect(new NoiseSuppressionEffect()).then(() => {
      console.log('Noise suppression effect applied to audio track');
    });
  }
}

function disableNoiseSuppressionEffect() {
  const audioTrack = getLocalTrack(MEDIA_TYPE.AUDIO)?.originalTrack;
  if (audioTrack) {
    audioTrack
      .setEffect(undefined)
      .then(() => {
        console.log('Noise suppression effect removed from audio track');
      })
      .catch((error: unknown) => {
        console.error('Error removing noise suppression effect:', error);
      });
  }
}

useTracksStore.subscribe(
  state =>
    state.tracks.find(t => t.mediaType === MEDIA_TYPE.AUDIO && t.local)
      ?.originalTrack,
  audioTrack => {
    if (audioTrack) {
      const enableNoiseReduction = useBaseStore.getState().enableNoiseReduction;
      if (enableNoiseReduction) {
        enableNoiseReductionEffect();
      }
    }
  },
);

useBaseStore.subscribe(
  state => state.enableNoiseReduction,
  enableNoiseReduction => {
    if (enableNoiseReduction) {
      enableNoiseReductionEffect();
    } else {
      disableNoiseSuppressionEffect();
    }
  },
);
